const Video = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <path
      d="M6.5 5.82056V10.1794C6.5 10.4293 6.77363 10.5828 6.98686 10.4525L10.246 8.46076C10.5906 8.2502 10.5906 7.74977 10.246 7.53921L6.98686 5.54751C6.77363 5.4172 6.5 5.57067 6.5 5.82056ZM4.5 3C3.11929 3 2 4.11929 2 5.5V10.5C2 11.8807 3.11929 13 4.5 13H11.5C12.8807 13 14 11.8807 14 10.5V5.5C14 4.11929 12.8807 3 11.5 3H4.5ZM3 5.5C3 4.67157 3.67157 4 4.5 4H11.5C12.3284 4 13 4.67157 13 5.5V10.5C13 11.3284 12.3284 12 11.5 12H4.5C3.67157 12 3 11.3284 3 10.5V5.5Z"
      fill="currentColor"
    />
  </svg>
);

export default Video;
